import React from 'react';
import { createRoot } from 'react-dom/client';
import { store } from './store/store';

import App from './app';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App store={store} />
  </React.StrictMode>,
);
